import { render, staticRenderFns } from "./ModelLogo.vue?vue&type=template&id=0a8614c0&"
import script from "./ModelLogo.vue?vue&type=script&lang=ts&"
export * from "./ModelLogo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports